import Cojiro from "../../../core/assets/oot/classic/OoT_Cojiro_Icon.png";
import Item from "../../../core/items/Item";
import StaticItem from "../../../core/items/StaticItem";
import OotItem from "./OotItem";
import { SimpleItemProps } from "./SimpleItemProps";

  let id = "OoT_Cojiro"
const CojiroItem = () => {

  

    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <Item id={id} image={Cojiro} title="Cojiro" updateItem={updateOotItem} item={item} isMajor
            />
        }}
    </OotItem>
}

export default CojiroItem;


export const SimpleCojiroItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={Cojiro}
        onClick={props.onClick}
        name={id}
    />



}